import React from 'react';
import { Form } from 'react-bootstrap';

const HfDateInput = (props) => {

    // Enforce min is less than max
    if (props.min && props.max) {
        if (new Date(props.min) > new Date(props.max)) {
            throw new Error('min must be less than max');
        }
    }

    const handleBlur = (e) => {
        // Enforce value is set between min/max
        if (e.target.value && props.min && new Date(e.target.value) < new Date(props.min)) {
            e.target.value = props.min;
            if (props.onChange) {
                props.onChange(e);
            }
        } else if (e.target.value && props.max && new Date(e.target.value) > new Date(props.max)) {
            e.target.value = props.max;
            if (props.onChange) {
                props.onChange(e);
            }
        }
    }

    return (
        <Form.Control type="date" onBlur={handleBlur} {...props} />
    )
};

export default HfDateInput;
